import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import Vue from "vue";
import { uniqueId } from "lodash";
export const SET_ALL_CAMPAIGNS = "SET_ALL_CAMPAIGNS";
export const SET_ALL_CAMPAIGNS_ONE = "SET_ALL_CAMPAIGNS_ONE";
export const SET_CURRENT_CAMPAIGN = "SET_CURRENT_CAMPAIGN";
export const SET_AUTOMATION = "SET_AUTOMATION";
export const SET_TRIGGER_MAPPER = "SET_TRIGGER_MAPPER";
export const SET_TRIGGER = "SET_TRIGGER";
export const REMOVE_TRIGGER = "REMOVE_TRIGGER";
export const SET_TRIGGER_ARGUMENT = "SET_TRIGGER_ARGUMENT";
export const SET_STAGE = "SET_STAGE";
export const REMOVE_STAGE = "REMOVE_STAGE";
export const REMOVE_CLIENT = "REMOVE_CLIENT";
export const SET_CURRENT_CAMPAIGN_CLIENTS = "SET_CURRENT_CAMPAIGN_CLIENTS";
const mutations = {
  [SET_ALL_CAMPAIGNS]: (state, campaigns) => {
    state.campaigns = campaigns;
  },
  [SET_ALL_CAMPAIGNS_ONE]: (state, {
    campaign,
    index
  }) => {
    Vue.set(state.campaigns, index, campaign);
  },
  [SET_CURRENT_CAMPAIGN]: (state, campaign) => {
    if (campaign.triggers) {
      var _context;
      campaign.triggers = _mapInstanceProperty(_context = campaign.triggers).call(_context, t => _objectSpread(_objectSpread({}, t), {}, {
        _localId: uniqueId()
      }));
    }
    Vue.set(state, "currentCampaign", _objectSpread(_objectSpread({}, state.currentCampaign), campaign));
  },
  [SET_CURRENT_CAMPAIGN_CLIENTS]: (state, clients) => {
    Vue.set(state.currentCampaign, "clients", clients);
  },
  [SET_AUTOMATION]: (state, automation) => {
    state.automation = automation;
  },
  [SET_TRIGGER_MAPPER]: (state, map) => {
    state.triggerMapper = map;
  },
  [SET_TRIGGER]: (state, {
    trigger,
    _localId
  }) => {
    var _context2;
    let indexOfTarget = _findIndexInstanceProperty(_context2 = state.currentCampaign.triggers).call(_context2, t => t._localId == _localId);
    if (indexOfTarget == -1) {
      indexOfTarget = state.currentCampaign.triggers.length;
    }
    Vue.set(state.currentCampaign.triggers, indexOfTarget, trigger);
  },
  [REMOVE_TRIGGER]: (state, _localId) => {
    var _context3;
    const indexOfTarget = _findIndexInstanceProperty(_context3 = state.currentCampaign.triggers).call(_context3, t => t._localId == _localId);
    Vue.delete(state.currentCampaign.triggers, indexOfTarget);
  },
  [SET_STAGE]: (state, {
    stage,
    index
  }) => {
    Vue.set(state.currentCampaign.stages, index, stage);
  },
  [REMOVE_STAGE]: (state, index) => {
    Vue.delete(state.currentCampaign.stages, index);
  },
  [REMOVE_CLIENT]: (state, index) => {
    Vue.delete(state.currentCampaign.clients, index);
  }
};
export default mutations;